import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getUserId, getType } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress Configuration

// permission judge function

const whiteList = ['/login', '/auth-redirect']// no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getUserId()&&getType()!=2) { // determine if there has token
    /* has userId*/
    if((from.path == '/dashboard'&&to.path == '/setting')||(from.path == '/login'&&to.path == '/setting')){
      store.commit('SET_SETLOADING',true)
      setTimeout(() => {
        store.commit('SET_SETLOADING',false)
      }, 1000)
      store.commit('SET_LOADING',true)
      setTimeout(() => {
        store.commit('SET_LOADING',false)
      }, 1000)
    }
    if(to.path == '/setting'){
      to.meta.keepAlive = true
    }else if(from.path == '/setting'&&to.path != '/selectPoint'){
      from.meta.keepAlive = false
    }

    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if(store.getters.role == ''){
        store.dispatch('GetUserInfo').then(res => { // 拉取user_info
          next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else if(getUserId()&&getType()==2){
    if (to.path === '/login'||to.path === '/'||to.path === '/dashboard') {
      next({ path: '/expertlibrary' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      next()
    }
  } else {
    /* has no userId*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
